
import NuxtImage from '~/components/Modules/Common/NuxtImage'

export default {
  components: { NuxtImage },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeDot: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      // watch for current slide
      this.$watch('$refs.carousel.currentSlide', (newSlide) => {
        this.activeDot = newSlide
      })
    },
    handleScroll(i) {
      this.activeDot = i
    },
    handleClick(index) {
      // reset tweens if carousel nav button is clicked again
      this.$refs.carousel.changeSlide(index, () => (this.activeDot = index))
    },
  },
}
